/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDebugPreview = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m8.8 19.3-1-1.7 3-1.7 1 1.7zm4.7-2.8-1-1.7 3-1.8 1 1.7zm-7.5 0H4V13h2zM6 11H4V7.5h2zm9.6 0-3-1.8 1-1.7 3 1.8zm-4.8-2.8-3-1.8 1-1.7 3 1.8z"
      fill="currentcolor"
    />
    <path d="m17.3 12 1-1.7 3 1.7-3 1.7zM6 18.5H4V22l3-1.7zm0-13H4V2l3 1.7z" />
  </Icon>
);
export { SvgDebugPreview as DebugPreview };
